import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Popper } from "../popper/Popper";
import { PopperBox } from "../popper/PopperBox";
import * as Styled from "./Tooltip.styled";
const TooltipComponent = forwardRef((props, _ref) => {
    const { trigger, contents, contentProps, mode = "description", delay, isSilent, overlay, ...otherProps } = props;
    const popperBoxProps = {
        children: null,
        colorScheme: "alchemyDark",
        hasArrow: true,
        maxWidth: contentProps ? (contentProps.maxWidth ? `${contentProps.maxWidth}px` : "none") : "300px",
        ...contentProps
    };
    /* DES-2482
    if (mode === "popover") {
      // TODO: change to console.warn in the next major
      // eslint-disable-next-line no-console -- using this to soft-deprecate the prop
      console.info(`[ALCHEMY] <Tooltip mode="popover"> is deprecated, use <Popper> instead`);
    }
    */
    return (_jsx(Popper, { "data-testid": "Tooltip", trigger: trigger, mode: mode === "popover" ? "popover" : "tooltip", overlay: overlay ? overlay : _jsx(PopperBox, { ...popperBoxProps, children: contents }), tooltipOptions: mode === "popover" ? undefined : { delay, mode: isSilent ? "silent" : mode }, ...otherProps }));
});
TooltipComponent.displayName = "Tooltip";
TooltipComponent.defaultProps = {
    delay: 120,
    placement: "top"
};
export const Tooltip = Object.assign(TooltipComponent, {
    StyledHeader: Styled.TooltipHeader,
    StyledContent: Styled.TooltipContent,
    StyledFooter: Styled.TooltipFooter
});
Tooltip.displayName = "Tooltip";
